import * as styled from '../styles/stats-strip';

type Props = {
  waitlistCount: number | null;
};

export const StatsStrip = ({ waitlistCount }: Props) => (
  <styled.StatsStrip>
    <styled.StatCard>
      <styled.StatIcon>👥</styled.StatIcon>
      <styled.StatNumber>
        {waitlistCount === null ? '—' : `${waitlistCount.toLocaleString()}+`}
      </styled.StatNumber>
      <styled.StatLabel>Spots claimed</styled.StatLabel>
    </styled.StatCard>
    <styled.StatCard>
      <styled.StatIcon>🛡</styled.StatIcon>
      <styled.StatNumber>100%</styled.StatNumber>
      <styled.StatLabel>Verified reviews</styled.StatLabel>
    </styled.StatCard>
    <styled.StatCard>
      <styled.StatIcon>⭐</styled.StatIcon>
      <styled.StatNumber>4.9</styled.StatNumber>
      <styled.StatLabel>Average rating</styled.StatLabel>
    </styled.StatCard>
  </styled.StatsStrip>
);
